/**
 * @file error.ts
 * @author markJia(markjia@tencent.com)
 */

export const COMMON_INTERNAL_ERROR_MSG = '服务异常，请稍后重试';
